import moment from "moment";

const acceptedDateFormats = [
  "YYYY-MM-DD",
  "DD/MM/YYYY",
  "DD-MM-YYYY",
  moment.ISO_8601,
];

export const normalizeRangeDate = (value) => {
  if (!value) return "";

  if (moment.isMoment(value)) {
    return value.format("YYYY-MM-DD");
  }

  if (value instanceof Date) {
    return moment(value).format("YYYY-MM-DD");
  }

  const strictParsedDate = moment(value, acceptedDateFormats, true);
  if (strictParsedDate.isValid()) {
    return strictParsedDate.format("YYYY-MM-DD");
  }

  const fallbackDate = moment(value);
  return fallbackDate.isValid() ? fallbackDate.format("YYYY-MM-DD") : "";
};

export const resolveRangeLabel = (rangeLabel) =>
  typeof rangeLabel === "string" && rangeLabel.trim()
    ? rangeLabel
    : "Custom Range";
